export const applySize = (clientBanner: number) => {
  switch (clientBanner) {
    case 1:
      return 'w-full';
    case 2:
      return 'w-1/2';
    case 3:
      return 'w-1/2 lg:w-1/3';
    default:
      return 'w-1/2 lg:w-1/4';
  }
};
